<template lang="pug">
  aside-modal(id="payment-modal" width="w-xxl")
    span(slot="header-text") {{ header }}
    div.p-a(slot="body")
      div(v-if="!loading && payment !== null")
        component(
          v-bind:is="getComponent(payment)"
          :ref="getComponent(payment)"
          :payment="payment"
          @payment-created="onPaymentCreated"
          @payment-updated="onPaymentUpdated"
        )

      div(v-else)
        h1.text-center
          v-loading(loader="fetch-payment")

    button.btn.btn-fw.primary(slot="footer" :disabled="loading || !canManagePayments" @click="submit")
      v-loading(loader="save-payment") Save
</template>

<script>
import { mapActions } from 'vuex';
import Auth from '@js/plugins/auth';
import BoostForm from './custom/boost-form.vue';
import EmptyForm from './custom/empty-form';
import EWalletForm from './custom/e-wallet-form.vue';
import GhlForm from './custom/ghl-form.vue';
import MaybankForm from './custom/maybank-form.vue';
import GobizForm from './custom/gobiz-form.vue';
import IpayForm from './custom/ipay-form.vue';
import PaymentForm from './settings-payment-form.vue';
import M1PaymentForm from './custom/m1-payment-form.vue';
import MpayForm from './custom/mpay-form.vue';
import TouchNGoForm from './custom/touch-n-go-form.vue';
import NttForm from './custom/ntt-form.vue';
export default {
    components: {
        BoostForm,
        EmptyForm,
        EWalletForm,
        GhlForm,
        MaybankForm,
        PaymentForm,
        GobizForm,
        IpayForm,
        M1PaymentForm,
        MpayForm,
        TouchNGoForm,
        NttForm,
    },

    data() {
        return {
            payment: null,
        };
    },

    computed: {
        canManagePayments() {
            return Auth.hasPermissionTo('franchise_manage_payments');
        },

        header() {
            if (this.payment !== null && this.payment.source !== null) {
                switch (this.payment.source) {
                    case 'boost':
                        return 'Boost';
                    case 'ghl':
                        return 'GHL';
                    case 'maybank_qr_pay':
                        return 'Maybank QRPay';
                    case 'ipay_234':
                        return 'AliPay';
                    case 'ipay_336':
                        return 'TouchNGo';
                    case 'ipay_338':
                        return 'Unionpay';
                    case 'ipay_305':
                        return 'WechatPay CN';
                    case 'ipay_343':
                        return 'WechatPay MY';
                    case 'sunmi_gobiz':
                        return 'GoBiz';
                    case 'sunmi_ipay':
                        return 'iPay';
                    case 'm1_payment':
                        return 'Mobility One';
                    case 'mpay':
                        return 'MPay';
                    case 'touch_n_go':
                        return 'Touch N Go';
                    case 'ntt':
                        return 'Adaptis';
                }
            }

            if (this.payment !== null && this.payment.id !== undefined) {
                return 'Update Payment';
            } else {
                return 'Create Payment';
            }
        },

        loading() {
            return this.onLoading('fetch-payment');
        },
    },

    methods: {
        ...mapActions('payment', ['getPayment']),

        getComponent(payment) {
            if (this.payment !== null) {
                let source = payment.source;

                switch (source) {
                    case null:
                        return 'payment-form';
                    case 'boost':
                        return 'boost-form';
                    case 'ghl':
                        return 'ghl-form';
                    case 'maybank_qrpay':
                        return 'maybank-form';
                    case 'ipay_234':
                    case 'ipay_336':
                    case 'ipay_338':
                    case 'ipay_343':
                    case 'ipay_305':
                        return 'e-wallet-form';
                    case 'sunmi_gobiz':
                        return 'gobiz-form';
                    case 'sunmi_ipay':
                        return 'ipay-form';
                    case 'm1_payment':
                        return 'm1-payment-form';
                    case 'mpay':
                        return 'mpay-form';
                    case 'touch_n_go':
                        return 'touch-n-go-form';
                    case 'ntt':
                        return 'ntt-form';
                }
            }

            return 'empty-form';
        },

        getForm() {
            let form = this.getComponent(this.payment);
            return this.$refs[form];
        },

        submit() {
            this.getForm().submit();
        },

        showForm(payment = null) {
            if (this.loading) {
                return;
            }

            this.showModal();

            if (payment !== null) {
                this.payment = payment;
            } else {
                this.payment = {
                    name: '',
                    type: 0,
                    preset_amount: null,
                    require_reference: false,
                    require_drawer_kick: false,
                    outlets: [],
                    source: null,
                };
            }

            this.$nextTick(() => {
                this.getForm().resetErrors();
                this.getForm().resetPayment();
            });
        },

        showModal() {
            $(this.$el).modal('show');
        },

        hideModal() {
            $(this.$el).modal('hide');
        },

        refresh() {
            this.$parent.refresh();
        },

        onPaymentCreated() {
            this.refresh();
        },

        onPaymentUpdated() {
            this.hideModal();
            this.refresh();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-form-modal.vue